import React from 'react'
import Details from './Details'
import Foter from './Foter'
import Header from './Header'

const Containar = () => {
    return (
        <div className="">
           <Header />
          <Details />
           <Foter />
        </div>
    )
}

export default Containar
